import React from 'react';

import { Link } from 'react-router-dom';
import { Card } from '@betareader/design-system';
import AppIcon from '../AppIcon';
import { withTranslation, Trans } from 'react-i18next';

const _isValidProfile = (userProfile, user) => {
  let { displayName, emailVerified } = userProfile;
  // there is a delay in email verified state via the api,
  // so take this directly from the user object
  if (!emailVerified && user) {
    emailVerified = user.emailVerified;
  }
  return displayName && displayName.length > 0 && emailVerified;
};

const _hasValidBook = (writing) => {
  return writing.filter((book) => {
    if (book.privacy !== 'listed') {
      return false;
    }
    if (book.wordCount <= 0) {
      return false;
    }
    // listed books with wordCount greater than 0 are considered valid
    return true;
  }).length > 0;
};

// stateless component
export const UnlockSignupBonusMessage = ({ userProfile, user, writing = [] }) => (
  <Card style={{padding: '1.5rem', borderLeft: '4px solid var(--br-accent)'}}>
    <Trans i18nKey='unlockBonusText'>
      <h2 style={{fontWeight: 'normal'}}>Unlock your signup bonus!</h2>
      <p style={{ fontWeight: 'lighter' }}>It looks like you were referred by a friend - follow the below steps to unlock your mutual sign-up bonus!</p>
      <ol style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
        gap: 12, paddingLeft: 20}}>
        <li>
          <Link to='/account/profile'>
            <AppIcon name={_isValidProfile(userProfile, user) ? 'check' : 'user'} />{' '}
            <strong>Validate account</strong>
          </Link>
          <p>You need a valid name and email address</p>
        </li>
        <li>
          <Link to='/books/new'>
            <AppIcon name={_hasValidBook(writing) ? 'check' : 'book'} />{' '}
            <strong>List manuscript</strong>
          </Link>
          <p>List the manuscript you want to test</p>
        </li>
        <li>
          <a href={process.env.REACT_APP_READER_HOST} target='betareader.io_reader' rel='noopener noreferrer'>
            <AppIcon name='clock outline' />{' '}
            <strong>Wait</strong>
          </a>
          <p>It takes around 3 days for us to validate</p>
        </li>
      </ol>
    </Trans>
  </Card>
);

export default withTranslation()(UnlockSignupBonusMessage);
